import { render, staticRenderFns } from "./PhoneNumberLink.vue?vue&type=template&id=2fc348cc&"
import script from "./PhoneNumberLink.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports